import { localize } from '../filters';
import { upperFirst } from '../helpers';
import { CustomValue, Indicator, IndicatorState } from '../../store/indicators';

export class IndicatorItem {

    private readonly _indicator: Indicator;
    private readonly classes: string[] = [];

    constructor(indicator: Indicator) {
        this._indicator = indicator;
    }

    public get indicator(): Indicator {
        return this._indicator;
    }

    public get name(): string {
        return this._indicator.name;
    }

    public get state(): IndicatorState {
        return this._indicator.state;
    }

    public get hasValue(): boolean {
        return this._indicator.state === IndicatorState.Value;
    }

    public get hasError(): boolean {
        return this._indicator.state === IndicatorState.Error;
    }

    public get isEmpty(): boolean {
        return this._indicator.state === IndicatorState.Empty;
    }

    public get isNotAvailable(): boolean {
        return this._indicator.state === IndicatorState.NotAvailable;
    }

    public get displayName(): string {
        return localize(upperFirst(this._indicator.name), 'Indicator');
    }

    public get displayValues(): CustomValue[] | null {
        const value = this._indicator.value;
        const customValues = this._indicator.customValues;

        const result: CustomValue[] = [];

        if (typeof value === 'undefined') {
            return null;
        }

        if (typeof value === 'number') {
            result.push({ value });

            if (customValues && customValues.length > 0) {
                customValues.forEach((item: CustomValue) => {
                    if (typeof item.value === 'number') {
                        result.push({ type: item.type, value: item.value });
                    }
                });
            }
        }

        return result;
    }

    public get class(): string {
        return this.classes.join(' ');
    }

    /**
     * Adds class to the indicator element classes
     * @param {string} className Added class
     */
    public addClass(className: string): void {
        if (this.classes.findIndex(x => x === className) < 0) {
            this.classes.push(className);
        }
    }

    /**
     * Removes class from the indicator element classes
     * @param {string} className Removed class
     */
    public removeClass(className: string): void {
        for (let idx = this.classes.findIndex(x => x === className);
            idx >= 0;
            idx = this.classes.findIndex(x => x === className)) {
            this.classes.splice(idx, 1);
        }
    }
}
